/* eslint-disable no-shadow */
import { Formik, Form } from 'formik';
import { Container, Row, Col, Button } from 'react-bootstrap';
import * as yup from 'yup';
import { CheckBox, DatePicker } from 'components';
import InputPhone from 'newComponents/TableFlow/InputPhone';
import React, { useEffect, useState, useRef } from 'react';
import { useWindowSize } from 'hooks';
import HonoredGuestsName from './HonoredGuestsName';
import './index.scss';
import Guests from '../Guests';
import SpecialDate from '../SpecialDate';
import TermsPDF from '../../../newComponents/CreateEvent/TermsPDF';
import styles from'../../../newComponents/CreateEvent/TermsPDF/styles.module.sass';


const DefaultGuest = [
  {
    id: '1',
    name: 'Nombre',
    order: null,
  },
];

const HonoredGuestsForm = ({
  handleBack,
  labels,
  touched,
  errors,
  handleSubmit,
  values,
  valueComplete
}) => {

  const [, { isMobile }] = useWindowSize()
  const eventToShow = [10, 11, 6, 3, 8];
  const showHonoredDisclaimer = eventToShow.includes(valueComplete.select_event?.category.id)
  
  
  return (
    <section className="HonoredGuests mb-1 mb-lg-0">
      <Container>
        <Form onSubmit={handleSubmit}>
          {labels.map((item, i) => (
            <HonoredGuestsName
              key={item?.id}
              isFirst={i === 0}
              hideResponsable={values.otro}
              touched={touched}
              errors={errors}
              {...item}
            />
          ))}
          {showHonoredDisclaimer && (
            <div className='row'>
              {
                !isMobile && (
                  <>
                    <div className="d-none d-lg-block col-lg-2" />
                    <div className='col-lg-10 col-12'>
                      <div className="HonoredGuests_paragraph">
                        <p> * Si el festejado es menor de edad deberá seleccionar otro
                          <span className="customColor"> RESPONSABLE DEL EVENTO </span> y en
                          <span className="customColor"> OTRO </span> capturar el nombre de  una persona mayor de 18 años para efectos de cierre del evento y  términos legales.
                        </p>
                      </div>
                    </div>
                  </>
                )
              }
            </div>
          )}
          {values?.otro && (
            <HonoredGuestsName
              label="Otro"
              id="otro"
              noResponsable
              touched={touched}
              errors={errors}
            />
          )}

          <Row className="">
            <Col md={12} lg={7} className="col-md-7 offset-md-3">
              <CheckBox
                label={
                  values.otro ? 'Responsable del evento' : 'Otro responsable'
                }
                name="otro"
                containerClassName="col-md-7 offset-md-1"
              />
            </Col>
          </Row>
        </Form>
      </Container>
    </section>
  )
};

const HonoredGuests = ({
  values,
  updateStep,
  onSaveData,
  handleBack,
  handleNext,
  valueComplete,
}) => {
  
  const [, { isMobile }] = useWindowSize()
  let validation = {};
  const formRef = useRef(null)

  let labels = valueComplete.select_event?.category.labels?.filter(
    (x) => x.name !== 'Otro'
  );

  if (!labels?.length) {
    labels = DefaultGuest;
  }

  const val = {};
  const defaultValues = {
    otro: false,
    responsable: labels[0].id,
    otro_firstname: '',
    otro_lastname: '',
  };

  labels.map((item) => {
    val[`${item.id}_firstname`] = yup
      .string()
      .required('Requerido')
      .min(3, 'Mínimo')
      .max(100, 'Máximo');
    val[`${item.id}_lastname`] = yup
      .string()
      .required('Requerido')
      .min(3, 'Mínimo')
      .max(100, 'Máximo');
    defaultValues[`${item.id}_firstname`] = '';
    defaultValues[`${item.id}_lastname`] = '';
    return true;
  });

  const ifOtro = (val, { parent }) => (parent.otro ? parent.otro && val : true);
  const testResponsable = (val, { parent }) =>
    parent.otro ? true : val && val !== '';

  validation = yup.object().shape({
    ...val,
    otro_firstname: yup
      .string()
      .test('required', 'Requerido', ifOtro)
      .min(3, 'Mínimo')
      .max(100, 'Máximo'),
    otro_lastname: yup
      .string()
      .test('required', 'Requerido', ifOtro)
      .min(3, 'Mínimo')
      .max(100, 'Máximo'),
    responsable: yup
      .string()
      .test('required', 'Se requiere escoger un responsable', testResponsable),
  });

  const handleFormikSubmit = (submitValues) => {

    console.log('++++++++++++++++++++ handleFormikSubmit ++++++++++++++++++++')
    console.log('++++++++++++++++++++llegue acaaaaa ++++++++++++++++++++')

    const celebrated = labels.map((label) => ({
      label_id: label.id,
      name: submitValues[`${label.id}_firstname`],
      last_name: submitValues[`${label.id}_lastname`],
      is_responsable: submitValues.otro
        ? false
        : label.id === parseInt(submitValues.responsable, 10),
    }));

    const data = {
      ...submitValues,
      celebrate_labels: celebrated,
      valid: true,
    };

    if (submitValues.otro) {
      data.responsable_name = submitValues.otro_firstname;
      data.responsable_last_name = submitValues.otro_lastname;
    }

    onSaveData(data);
    handleNext();
  };


  const [acceptsTermsAndConditions, setAcceptsTermsAndConditions] = useState(false)
  const [vaidationData, setValidationData] = useState(false)
  const [ dataForm, setDataForm ] = useState(null)
  
  const toggleCheckbox = () => {
    setAcceptsTermsAndConditions(!acceptsTermsAndConditions);
  }

  useEffect(()=>{
    let validation
    if(acceptsTermsAndConditions === true && String(dataForm?.phone_customer)?.length === 10 && dataForm?.eventDate?.length >= 8 && valueComplete?.guests?.guests >= 1){
      validation = true
    }else{
        validation = false    
    }
    setValidationData(validation)
  },[acceptsTermsAndConditions, dataForm, valueComplete])


  const [showFormActive, setShowFormActive ] = useState(true)
  const textEvent = 'Cuéntanos todo sobre tu evento'
  const textTerm = 'Términos y condiciones'

  const showForm = () => {
    window.scrollTo(0, 0);
    updateStep(null)
    const steps = document.querySelector('.table_breadcrumb').innerText.split(' de ')
    const first = Number(steps[0])
    // const text = document.querySelector('.table_title.mt-lg-1.mt-md-2').innerText
    // document.querySelector('.table_title.mt-lg-1.mt-md-2').innerText = text?.replace(textTerm, textEvent)
        document.querySelector('.table_title.mt-lg-1.mt-md-2').innerText = `${first -1}. ${textEvent}`
    setShowFormActive(true)
  }
  const hiddenTerms = () => {
    window.scrollTo(0, 0);
    const steps = document.querySelector('.table_breadcrumb').innerText.split(' de ')
    const first = Number(steps[0])
    updateStep(first + 1)
    
    // const text = document.querySelector('.table_title.mt-lg-1.mt-md-2').innerText
    // document.querySelector('.table_title.mt-lg-1.mt-md-2').innerText = text?.replace(textEvent,textTerm)
    document.querySelector('.table_title.mt-lg-1.mt-md-2').innerText = `${first +1}. ${textTerm}`
    setShowFormActive(false)
  }
  const handleSubmit = () => {
    // formRef.current.submit()
  }


  return (
    <section className="HonoredGuests">
      <Formik
        initialValues={values || defaultValues}
        validationSchema={validation}
        onSubmit={handleFormikSubmit}
        
      >
        {(props) => (
          <Form
            ref={formRef}
          >
            <div className={showFormActive ? styles?.showForm : styles?.hiddenForm}>
              <HonoredGuestsForm
                labels={labels}
                onSaveData={onSaveData}
                {...props}
                valueComplete={valueComplete}
              />

              <InputPhone
                setDataForm={setDataForm}
              />

              <SpecialDate
                onSaveData={onSaveData}
                valueComplete={valueComplete}
              />
              {/* <DatePicker
              hasValidation={false}
                  name="value"
                  label="Fecha del evento:"
                  value={dateValue}
                  onChange={handleDateChange}

              /> */}
              <Guests
                onSaveData={onSaveData}
                valueComplete={valueComplete}
                toggleCheckbox={toggleCheckbox}
                showCheck={false}
                selectedInitial
              />
              <div className="table_flow_buttons mt-2">
                {!isMobile && (
                  <Button
                    onClick={handleBack}
                    variant="secondary"
                    className="btn-with-shadow"
                  >
                    Atras
                  </Button>
                )}              
                <Button 
                  onClick={hiddenTerms}
                  className='btn-with-shadow' 
                  disabled={!vaidationData} 
                >Siguiente</Button>
              </div>
            </div>

            <div className={showFormActive ? styles?.hiddenTerms : styles?.showTerms}>
              <TermsPDF  
                  valueComplete={valueComplete}
                  showFormActive={showFormActive}
                  showForm={showForm}
                  hiddenTerms={hiddenTerms}
                  handleSubmit={handleSubmit}
                  isMobile={isMobile}
              />
            </div>
          </Form>

        )}
      </Formik>
    </section>
  );
};

export default HonoredGuests;
